import React from 'react';
import { getInitials } from '@/shared/utils/displayName';

/**
 * Component that displays user names in a privacy-friendly way
 * Shows display names only - NEVER shows email addresses
 */
export function UserDisplayName({ 
  displayName, // The display name to show
  className = '',
  showInitials = false,
  initialsClassName = ''
}) {
  // Validate required props
  if (!displayName || typeof displayName !== 'string') {
    return (
      <span className={`text-gray-500 italic ${className}`}>
        Anonymous User
      </span>
    );
  }

  // Generate initials from display name
  const initials = getInitials(displayName);
  
  if (showInitials) {
    return (
      <div className="flex items-center space-x-2">
        <div className={`w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-medium ${initialsClassName}`}>
          {initials}
        </div>
        <div className="flex flex-col min-w-0">
          <span className={`font-medium truncate ${className}`}>
            {displayName}
          </span>
        </div>
      </div>
    );
  }
  
  return (
    <span className={`font-medium truncate ${className}`}>
      {displayName}
    </span>
  );
}